import initMobileNav from './modules/mobile-nav';
import initAccordion from './modules/accordion';
import initSliders from './modules/sliders';
import initVideoPlayer from './modules/video-player';
import initBlogFilter from './modules/blog-filter';
import initConstructionUpdates from './modules/construction-updates';
import initSpeakerTabs from './modules/speaker-tabs';
import initFadeIn from './modules/fade-in';
import initCountUp from './modules/count-up';
import initPanelSlider from './modules/panel-slider';
import initLoginMenu from './modules/login-menu';
import initSearch from './modules/search';
import initAlertBanner from './modules/alert-banner';
import initHeroVideo from './modules/hero-video';

initMobileNav();
initAccordion();
initSliders();
initVideoPlayer();
initBlogFilter();
initConstructionUpdates();
initSpeakerTabs();
initFadeIn();
initCountUp();
initPanelSlider();
initLoginMenu();
initSearch();
initAlertBanner();
initHeroVideo();
